import { 
    ACTUALIZAR__LIST_ACTIVOXPRODUCTO,
  } from "./productosXactivoActions";

  const componenteReducer = (state, action) => {
    switch(action.type){


        case  ACTUALIZAR__LIST_ACTIVOXPRODUCTO: {
            return {
                ...state,
                activoXproductoList
: action.payload
            }
        }

        default:
            return state;

    }
  }

  export default componenteReducer;